import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Paper, Typography } from '@material-ui/core';
import BarChart from 'components/@common/Charts/BarChart';
import InlineTextPopover from 'components/@common/InlineTextPopover';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import { ReportEntityType } from 'components/ReportsModule/types';
import { PrmStudentEngagementReportResult, ProductCurriculum } from 'types/schema-generated-types';
import useStyles from '../../common/styles';
import { buildOptions, buildSeries } from '../util';

type Props = {
  productCurriculum?: ProductCurriculum | null;
  prmStudentEngagementReport: PrmStudentEngagementReportResult;
};

const Engagement: React.FC<Props> = ({ prmStudentEngagementReport }) => {
  const classes = useStyles();
  const [, setQuery] = useReportQueryParams();
  const { t } = useTranslation('ReportsHelpCommon');

  const handleChartClick = (index: number): void => {
    const ids = prmStudentEngagementReport.studentCurriculumProgress.flatMap(
      progress => progress.studentId
    );
    setQuery({ entityType: ReportEntityType.STUDENT, entityId: ids[index] }, 'pushIn');
  };

  return (
    <>
      <Typography variant="h3" style={{ marginBottom: 6, fontWeight: 450 }}>
        Engagement
      </Typography>
      <Paper className={classes.container} style={{ justifyContent: 'flex-start' }}>
        <Container>
          <InlineTextPopover
            variant="h3"
            PopoverContentProps={{ description: t('prmSetAReporting') }}
          >
            Student Skills Progress
          </InlineTextPopover>
          <BarChart
            type="bar"
            series={buildSeries(prmStudentEngagementReport)}
            options={buildOptions(prmStudentEngagementReport)}
            onClick={handleChartClick}
          />
        </Container>
      </Paper>
    </>
  );
};

export default Engagement;
